import { useMutation } from "react-query";
import { unRegisterSubscription } from "../../../utils/pushNotification";
var useUnregisterNotification = function useUnregisterNotification() {
  return useMutation(function (token) {
    return unRegisterSubscription(token);
  });
};
export default useUnregisterNotification;